import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';
import type { Query } from '../op-types';

export function createInvestorRelationsQueries(client: StoxlyClient) {
  return createQueryKeys('investorRelations', {
    // ['investorRelations', 'content', { query }]
    content: (query: Query<'investorRelationsGetContent'>) => ({
      queryKey: [{ query }],
      queryFn: ({ signal }) => client.investorRelationsGetContent({ queries: query, signal }),
    }),

    // ['investorRelations', 'events', { query }]
    events: (query: Query<'investorRelationsGetEvents'>) => ({
      queryKey: [{ query }],
      queryFn: ({ signal }) => client.investorRelationsGetEvents({ queries: query, signal }),
    }),

    // ['investorRelations', 'transcript', { query }]
    transcript: (query: Query<'investorRelationsGetTranscript'>) => ({
      queryKey: [{ query }],
      queryFn: ({ signal }) => client.investorRelationsGetTranscript({ queries: query, signal }),
    }),

    // ['investorRelations', 'transcriptAudioSync', { query }] — fox F7: per-segment
    // timestamps. Kept OFF the transcript key on purpose: the transcript is a large,
    // 10-minute-stale payload while this one is small and polled while alignment runs.
    transcriptAudioSync: (query: Query<'investorRelationsGetTranscriptAudioSync'>) => ({
      queryKey: [{ query }],
      queryFn: ({ signal }) =>
        client.investorRelationsGetTranscriptAudioSync({ queries: query, signal }),
    }),

    // ['investorRelations', 'eventReactions', { query }] — fox F2: price reaction +
    // EPS surprise per announcement, joined client-side onto the events list.
    eventReactions: (query: Query<'investorRelationsGetEventReactions'>) => ({
      queryKey: [{ query }],
      queryFn: ({ signal }) =>
        client.investorRelationsGetEventReactions({ queries: query, signal }),
    }),
  });
}
